"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuLink = void 0;
const react_1 = __importDefault(require("react"));
const menu_styled_1 = require("./menu.styled");
const menu_label_1 = require("./menu-label");
/** Link opens a new page */
const MenuLink = ({ href, value, unit, title, size, setIsSelected, index = -1, tabIndex, currentLocation, }) => {
    return (react_1.default.createElement(menu_styled_1.StyledButton, { size: size, onClick: () => setIsSelected && setIsSelected(index), "$isSelected": !!href && (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.includes(href)), href: href, tabIndex: tabIndex },
        react_1.default.createElement(menu_label_1.MenuLabelWithUnit, { value: value, unit: unit, title: title })));
};
exports.MenuLink = MenuLink;
exports.MenuLink.displayName = 'MenuLink';
exports.default = exports.MenuLink;
//# sourceMappingURL=menu-link.js.map